module.exports = __webpack_public_path__ + "img/assoyoga.51c9008a.webp";